export const LOGOUT = "logout";
export const SET_USER = "setUser";
export const SET_MEMBER = "setMember";
export const SET_NAV_LIST = "setNavList";



// WEBPACK FOOTER //
// ./src/store/mutationTypes.js